module.exports = __webpack_public_path__ + "img/award-bg.355327b8.png";